import { render, staticRenderFns } from "./TagSummaryPage.vue?vue&type=template&id=363825af&"
import script from "./TagSummaryPage.vue?vue&type=script&lang=js&"
export * from "./TagSummaryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports